import { useState } from "react";
import AccordianComp from "../AccordianComp";
import styles from "./FaqsComp.module.css";

export default function FaqsComp({ question = [], answer = [] }) {
  const items = question.map((item, index) => ({
    question: item,
    answer: answer[index] ?? "",
  }));

  const [openIndex, setOpenIndex] = useState(items.length > 0 ? 0 : -1);

  return (
    <div className={styles.list}>
      {items.map((item, index) => (
        <AccordianComp
          key={`${item.question}-${index}`}
          question={item.question}
          answer={item.answer}
          isOpen={openIndex === index}
          onToggle={() => setOpenIndex((current) => (current === index ? -1 : index))}
        />
      ))}
    </div>
  );
}
